import { PLAYER_HAND, BANKER_HAND, } from './strings';

export const INITIAL_STATE = {
  [PLAYER_HAND]: { cards: [], },
  [BANKER_HAND]: { cards: [], },
};
